import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MenuComponent, MenuItem } from '@t-llevo/common-ui';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'edt-sidenav',
  standalone: true,
  templateUrl: './sidenav.component.html',
  styleUrls: ['./sidenav.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MenuComponent],
})
export class SidenavComponent {
  adminMenu: MenuItem[] = [
    {
      routerLinkUrl: '/summary',
      svgIcon: 'view-dasboard-outline',
      title: 'Resumen',
      isOpen: false
    },
    {
      routerLinkUrl: '/drivers',
      svgIcon: 'driver',
      title: 'Conductores',
      isOpen: false,
    },
    {
      routerLinkUrl: '/travel',
      svgIcon: 'location',
      title: 'Viajes',
      isOpen: false
    },
    {
      routerLinkUrl: '/travel-pricing',
      svgIcon: 'credit_card',
      title: 'Tarifas',
      isOpen: false
    },
    {
      routerLinkUrl: '/vehicles',
      svgIcon: 'vehicle',
      title: 'Tipos de vehículos',
      isOpen: false
    },
    {
      routerLinkUrl: '/version-control',
      svgIcon: 'data_table',
      title: 'Versiones',
      isOpen: false,
      children: [
        {
          routerLinkUrl: '/version-control/driver/',
          svgIcon: 'data_table',
          title: 'App-Conductores',
          isOpen: false
        },
        {
          routerLinkUrl: '/version-control/client',
          svgIcon: 'data_table',
          title: 'App-Clientes',
          isOpen: false
        }
      ]
    },
    {
      routerLinkUrl: '/user',
      svgIcon: 'account',
      title: 'Usuarios',
      isOpen: false
    },
    {
      routerLinkUrl: '/client',
      svgIcon: 'account',
      title: 'Clientes',
      isOpen: false
    },
  ];
}
